export default __webpack_public_path__ + "static/media/micimg5.64a2df59.webp";